export type ReferringChannelRequest =
  | { kind: 'visit'; channelId: string }
  | { kind: 'default' };

export function referringChannelRequest(input: {
  queryChannel?: string | null;
  pathChannel?: string | null;
}): ReferringChannelRequest {
  const specified = input.queryChannel?.trim() || input.pathChannel?.trim();
  if (specified) {
    return { kind: 'visit', channelId: specified };
  }
  return { kind: 'default' };
}
